export const Loading = () => {
  return (
    <div className="animate-pulse rounded-lg bg-white p-4 shadow-md">
      <div className="mb-2 h-4 w-2/3 rounded bg-gray-300" />
      <div className="mb-2 h-8 w-full rounded bg-gray-300" />
      <div className="mb-2 h-8 w-full rounded bg-gray-300" />
      <div className="h-8 w-1/2 rounded bg-gray-300" />
    </div>
  );
};
